module.exports = __webpack_public_path__ + "img/4.18cdce30.jpg";